// extracted by mini-css-extract-plugin
module.exports = {"errorPageContainer":"ErrorPages_errorPageContainer__Qny8s","errorTitle":"ErrorPages_errorTitle__9tcIy","errorCard":"ErrorPages_errorCard__mEQ0E"};